import { render, staticRenderFns } from "./overview-results.vue?vue&type=template&id=72b5e0c8"
import script from "./overview-results.vue?vue&type=script&lang=js"
export * from "./overview-results.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports